import { LinkSimple, PlusCircle } from '@phosphor-icons/react'
import type { ReactNode } from 'react'
import { cn } from '../lib/utils'
import { ParsleyMark } from './parsley-mark'

/**
 * The three Pro Level-up roles. Web's level-up role strings share these exact values, so they
 * are assignable to a LevelUpMarker `role` without importing across packages.
 */
export enum LevelUpRole {
  Hero = 'hero',
  Side = 'side',
  Unity = 'unity'
}

type RoleValue = `${LevelUpRole}`

const ICON_CLASS = 'size-[11px]'

const ROLE_ICON: Record<RoleValue, ReactNode> = {
  hero: <ParsleyMark filled className={ICON_CLASS} />,
  side: <PlusCircle weight="bold" className={ICON_CLASS} aria-hidden="true" />,
  unity: <LinkSimple weight="bold" className={ICON_CLASS} aria-hidden="true" />
}

interface LevelUpMarkerProps {
  role: RoleValue
  /** Accessible name and tooltip, e.g. "Hero move · Crispy-skin finish". Omit when a visible label sits beside it. */
  label?: string
  className?: string
}

/** An amber disc marking something a Pro Level-up adds: its ingredients, its steps. */
export function LevelUpMarker({ role, label, className }: LevelUpMarkerProps) {
  return (
    <span
      {...(label ? { role: 'img', 'aria-label': label, title: label } : { 'aria-hidden': true })}
      className={cn('inline-grid size-5 shrink-0 place-items-center rounded-full bg-amber-wash align-middle text-amber-strong', className)}>
      {ROLE_ICON[role]}
    </span>
  )
}
